export default {
  name: 'CalendarWithArrowLeftIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#93999F'
    }
  }
};